
export default {

  getAuthHeader: function () {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && user.Token) {
      return { Authorization: 'Bearer ' + user.Token }
    } else {
      return {}
    }
  },
  setupVueSession: function (vueRoot, loginResponse, courseKey) {
    vueRoot.userFullName = loginResponse.FullName
    vueRoot.userFirstName = loginResponse.FirstName
    vueRoot.userLastName = loginResponse.LastName
    vueRoot.scouterKey = loginResponse.ScouterKey
    vueRoot.courses = loginResponse.Courses
    vueRoot.isCourseDirector = loginResponse.IsCourseDirector
    if (courseKey) {
      this.setupCourse(vueRoot, courseKey)
    } else if (vueRoot.courses.length < 1) {
      this.teardownVueSession(vueRoot)
      return '/login'
    } else {
      this.setupCourse(vueRoot, vueRoot.courses[0].CourseKey)
    }
    vueRoot.isLoggedIn = true

    localStorage.setItem('user', JSON.stringify(loginResponse))

    if (vueRoot.courseScouterType === 'Participant') {
      return '/participant'
    } else if (vueRoot.courseScouterType === 'Staff') {
      return '/staff'
    }
  },
  setupCourse: function (vueRoot, courseKey) {
    for (let i = 0; i < vueRoot.courses.length; i++) {
      if (vueRoot.courses[i].CourseKey === courseKey) {
        vueRoot.courseKey = vueRoot.courses[i].CourseKey
        vueRoot.courseName = vueRoot.courses[i].CourseName
        vueRoot.courseScouterType = vueRoot.courses[i].CourseScouterType
        vueRoot.isAdmin = vueRoot.courses[i].IsAdmin
        vueRoot.isCourseDirector = vueRoot.courses[i].IsCourseDirector
        vueRoot.courseStatus = vueRoot.courses[i].CourseStatus
        break
      }
    }
  },
  teardownVueSession: function (vueRoot) {
    vueRoot.userFullName = null
    vueRoot.userFirstName = null
    vueRoot.userLastName = null
    vueRoot.courseKey = null
    vueRoot.courseName = null
    vueRoot.courseScouterType = null
    vueRoot.isAdmin = null
    vueRoot.scouterKey = null
    vueRoot.courses = null
    vueRoot.isLoggedIn = false
    vueRoot.isCourseDirector = null
    vueRoot.courseStatus = null

    localStorage.removeItem('user')
  }
}
